"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACDateTimeDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var moment_1 = __importDefault(require("moment"));
var ACTypography_1 = require("./ACTypography");
var ACDateTimeDisplay = function (props) {
    var getFormattedDateTime = function () {
        var _a;
        var format = props.format || 'DD-MM-YYYY HH:mm:ss';
        if (props.label) {
            // Try to parse the input as a date
            var parsedDate = (0, moment_1.default)(props.label);
            // If it's a valid date, format it
            if (parsedDate.isValid()) {
                return parsedDate.format(format);
            }
            // If it's not recognized as a valid date, return it as-is
            return props.label;
        }
        return (props === null || props === void 0 ? void 0 : props.showCurrentTime)
            ? (0, moment_1.default)().format(format)
            : ((_a = props === null || props === void 0 ? void 0 : props.labelSource) === null || _a === void 0 ? void 0 : _a.default) || null;
    };
    return ((0, jsx_runtime_1.jsx)(ACTypography_1.ACTypography, __assign({}, props, { element: "typography", name: props === null || props === void 0 ? void 0 : props.name, label: getFormattedDateTime() || '' })));
};
exports.ACDateTimeDisplay = ACDateTimeDisplay;
